var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2929 27.2931C27.6834 26.9026 27.6834 26.2695 27.2928 25.879L23.311 21.898C24.5641 20.2851 25.1554 18.2553 24.9644 16.2218C24.7734 14.1883 23.8145 12.3041 22.2829 10.9528C20.7514 9.60146 18.7624 8.88471 16.721 8.94846C14.6795 9.01221 12.7391 9.85166 11.2949 11.2959C9.85066 12.7401 9.01121 14.6805 8.94746 16.722C8.88371 18.7634 9.60046 20.7524 10.9518 22.2839C12.3031 23.8155 14.1873 24.7744 16.2208 24.9654C18.2543 25.1564 20.2841 24.5651 21.897 23.312L25.879 27.2931C26.2695 27.6835 26.9025 27.6835 27.2929 27.2931ZM17 23C15.8133 23 14.6533 22.6481 13.6666 21.9888C12.6799 21.3295 11.9108 20.3925 11.4567 19.2961C11.0026 18.1997 10.8838 16.9933 11.1153 15.8295C11.3468 14.6656 11.9182 13.5965 12.7574 12.7574C13.5965 11.9182 14.6656 11.3468 15.8295 11.1153C16.9933 10.8838 18.1997 11.0026 19.2961 11.4567C20.3925 11.9108 21.3295 12.6799 21.9888 13.6666C22.6481 14.6533 23 15.8133 23 17C22.9981 18.5907 22.3654 20.1158 21.2406 21.2406C20.1158 22.3654 18.5907 22.9981 17 23ZM0 11C0 10.4477 0.447715 10 1 10H7C7.55228 10 8 10.4477 8 11C8 11.5523 7.55228 12 7 12H1C0.447715 12 0 11.5523 0 11ZM0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1ZM0 6C0 5.44772 0.447715 5 1 5H15C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7H1C0.447715 7 0 6.55228 0 6Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarDetails);
export default __webpack_public_path__ + "static/media/navbar-details.b716b45b3015b7daee0a4de0b8b25618.svg";
export { ForwardRef as ReactComponent };